export default {
      id: "manufacture-date-usage",
      viewBox: "0 0 205 255",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#manufacture-date",
      toString: function () {
        return this.url;
      }
    }